import React from 'react'
import PropTypes from 'prop-types'

class RadioInput extends React.Component {

  componentDidMount() {
    require('./RadioInput.css');
  }

  render() {

    return (
      <input
        className="Radio"
        type='radio'
        checked={this.props.selected}
        onClick={() => this.props.onClick()}
        readOnly 
        disabled={!this.props.enabled} 
      />
    )
  }
}

RadioInput.defaultProps = {
    enabled: true,
    onClick: function() {},
    selected: false
}

RadioInput.propTypes = {
  enabled: PropTypes.bool,
  onClick: PropTypes.func.isRequired,
  selected: PropTypes.bool.isRequired
}

export default RadioInput


// WEBPACK FOOTER //
// ./src/Components/checkout/components/RadioInput/RadioInput.jsx